import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const CustomerEmail = ({
  inspection_report,
  setInspectionReport,
  activateSignature,
  setActivateSignature,  // <--- NEW: The setter
  urlID,
  signature
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [customerEmailButton, setCustomerEmailButton] = useState(
    inspection_report.customerEmail ? 'Update' : 'Add'
  );

  // ────────────────────────── NEW STATE ──────────────────────────
  const [noCustomer, setNoCustomer] = useState(false);   // ← checkbox state

  const submitCustomerEmail = async () => {
    const bodyData = { 
      status: 'addEmail',
      customer_email: inspection_report.customerEmail,
      customer_print: inspection_report.customerPrint,
      inspection_id: parseInt(urlID)
    };
    try {
      const response = await axios.post(`${apiUrl}/contracts_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      // Suppose your backend returns an array where index 0 is 'success'
      // OR if your backend returns { "success": true } as an object.
      // Adjust checks accordingly:
      if (Array.isArray(response.data) && response.data[0] === 'success') {
        setCustomerEmailButton('Update');
        // Activate the signature now that we have a successful response
        setActivateSignature(true);
      } else if (response.data.success) {
        // If your backend returns an object with "success" property
        setCustomerEmailButton('Update');
        // Activate the signature now that we have a successful response
        setActivateSignature(true);
      } else {
        console.error('Error adding email');
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
          position: "top-center"
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
          position: "top-center"
        });
      }
    }
  };

  // ───────────────────── NEW HELPER  (checkbox handler) ─────────────────────
  const handleNoCustomerToggle = async (e) => {
    const checked = e.target.checked;
    setNoCustomer(checked);

    if (checked) {
      try {
        const response = await axios.post(`${apiUrl}/contracts_crud.php`,
          {
            status: 'completeInspectionNoSign',   // ← adjust to the endpoint you use
            inspection_id: parseInt(urlID)
          },
          { headers: { 'Content-Type': 'application/json' } }
        );

        if(response.data.success) {
          toast.success('Inspection marked complete (no customer signature).', {
            position: 'top-center'
          });
          setActivateSignature(false);
          navigate('/t/tinspection');
        }
      } catch (error) {
        if (error.response?.status === 401) {
          navigate('/login');
        } else if (error.response?.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
            position: 'top-center'
          });
        } else {
          toast.error('Could not complete inspection.', { position: 'top-center' });
        }
      }
    }
  };


  return (
  // ────────────────────────── JSX (return) ──────────────────────────
  <div className="mb-5">
    <h5 className="font-bold text-gray-700 mb-2">
      Customer's Email <span className="text-red-500 text-sm">(required)</span>
    </h5>

    {/* NEW: No-customer checkbox */}
    <label className="flex items-center mb-2 text-sm font-medium text-gray-700">
      <input
        type="checkbox"
        className="mr-2 "
        checked={noCustomer}
        onChange={handleNoCustomerToggle}
      />
      No customer to sign (mark inspection complete)
    </label>
    <br />

    {/* Disable inputs when no-customer box is checked */}
    <input
      type="email"
      disabled={noCustomer}
      className="border p-2 w-full mb-2 disabled:bg-gray-100"
      placeholder="email@email.com"
      value={inspection_report.customerEmail || ''}
      onChange={e =>
        setInspectionReport({ ...inspection_report, customerEmail: e.target.value })
      }
    />

    <input
      type="text"
      disabled={noCustomer}
      className="border p-2 w-full mb-2 disabled:bg-gray-100"
      placeholder="Print Name"
      value={inspection_report.customerPrint || ''}
      onChange={e =>
        setInspectionReport({ ...inspection_report, customerPrint: e.target.value })
      }
    />

    <button
      disabled={
        noCustomer || !inspection_report.customerEmail || !inspection_report.customerPrint
      }
      onClick={submitCustomerEmail}
      className="bg-blue-500 text-white py-1 px-3 rounded text-sm mr-2 disabled:bg-gray-400"
    >
      {customerEmailButton}
    </button>

    {activateSignature && !noCustomer && (
      <button
        className="bg-blue-500 text-white py-1 px-3 rounded text-sm"
        onClick={signature}
      >
        Add Signature
      </button>
    )}
  </div>

  );
};

export default CustomerEmail;
